var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollabrativeDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.14748C2 2.40917 3.40918 1 5.14749 1H15.8489C17.5873 1 18.9964 2.40918 18.9964 4.14749V9.5388C18.9964 9.70329 18.932 9.86125 18.8171 9.97886L14.75 14.1389L8.93259 19.7101C8.81541 19.8223 8.65943 19.8849 8.49719 19.8849H5.14749C3.40918 19.8849 2 18.4757 2 16.7374V4.14748ZM9.2393 3.95166C8.783 3.95166 8.41309 4.32157 8.41309 4.77788C8.41309 5.23418 8.783 5.60409 9.2393 5.60409H15.2195C15.6758 5.60409 16.0457 5.23418 16.0457 4.77788C16.0457 4.32157 15.6758 3.95166 15.2195 3.95166H9.2393ZM5.77641 7.41455C5.3201 7.41455 4.9502 7.78446 4.9502 8.24077C4.9502 8.69707 5.3201 9.06698 5.77641 9.06698H15.2189C15.6752 9.06698 16.0451 8.69707 16.0451 8.24077C16.0451 7.78446 15.6752 7.41455 15.2189 7.41455H5.77641ZM5.77641 10.876C5.3201 10.876 4.9502 11.2459 4.9502 11.7022C4.9502 12.1585 5.3201 12.5284 5.77641 12.5284H13.3304C13.7867 12.5284 14.1566 12.1585 14.1566 11.7022C14.1566 11.2459 13.7867 10.876 13.3304 10.876H5.77641Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1275 11.3341C20.6359 10.8424 19.8387 10.8424 19.3471 11.3341L11.4128 19.2684C11.3622 19.319 11.3294 19.3846 11.3193 19.4553L10.9521 22.0259C10.9209 22.244 11.1079 22.431 11.326 22.3998L13.8965 22.0326C13.9673 22.0225 14.0329 21.9897 14.0835 21.9391L22.0178 14.0048C22.5095 13.5132 22.5095 12.716 22.0178 12.2243L21.1275 11.3341Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabrativeDocument);
export default __webpack_public_path__ + "static/media/collabrative_document.9f5c199a668e6da1c4c60649d1fb1ead.svg";
export { ForwardRef as ReactComponent };